import React from 'react';
import { Box } from '../Layout/Box';
import { useTextClasses } from './useTextClasses';
import { useTheme } from '../../theme';
import { join } from '../../utils/className';
/**
 * Represents text with no specific semantic meaning.
 * `Text` composes the `Box` component. By default, it renders a `div` element.
 * You can use the `tag` prop to change the element render, just like `as` prop from styled-components.
 *
 * @see https://fe-docs.int.getresponse.com/gr-ui-neo/index.html?path=/docs/components-text--page
 */
export const Text = React.forwardRef(({ children, fontSize, fontWeight, letterSpacing, lineHeight, variant, align, textTransform, isTruncated, wordBreak, textDecoration, whiteSpace, className, ...boxProps }, ref) => {
    const theme = useTheme();
    const classes = useTextClasses({
        variant,
        fontSize,
        fontWeight,
        letterSpacing,
        lineHeight,
        theme,
        align,
        isTruncated,
        textTransform,
        wordBreak,
        textDecoration,
        whiteSpace,
    });
    const title = isTruncated && typeof children === 'string' ? children : undefined;
    return (React.createElement(Box, { ref: ref, title: title, className: join(className, classes.text), ...boxProps }, children));
});
